import { render, staticRenderFns } from "./FormProntuario.vue?vue&type=template&id=50e0afaa&scoped=true&"
import script from "./FormProntuario.vue?vue&type=script&lang=js&"
export * from "./FormProntuario.vue?vue&type=script&lang=js&"
import style0 from "./FormProntuario.vue?vue&type=style&index=0&id=50e0afaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0afaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDialog,VForm,VIcon,VProgressCircular,VTextarea})
